import { render, staticRenderFns } from "./RipaStatutesGrid.vue?vue&type=template&id=498ad99f"
import script from "./RipaStatutesGrid.vue?vue&type=script&lang=js"
export * from "./RipaStatutesGrid.vue?vue&type=script&lang=js"
import style0 from "./RipaStatutesGrid.vue?vue&type=style&index=0&id=498ad99f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports